export const IMAGES = {
  LOGO: 'assets/logo.png',
  LOGO_DARK: 'assets/logo-clesame-dark.png',
  IDENTITY_POST: 'assets/identityPost.svg',
  MEMORIES1: 'assets/memories/memories1.webp',
  MEMORIES2: 'assets/memories/video.webm',
  MEMORIES3: 'assets/memories/family.jpg',
}
